import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalBase } from '../components/ModalBase';
import { getAccessList, getIsShowAccessModal, getOpenedAccessModelId, getSearchedUsers } from '../reducers/accessControl/accessControlReducer';
import { closeAccessModel, removeAccessModel, searchAccessModel, updateAccessModel } from '../sagas/accessSaga/accessSagaActions';
import { Autocomplete, Box, Button, TextField } from '@mui/material';
import { AccessUserItem } from './components/AccessUserItem';
import { AIAccessTypeEnum, CreateAccessesToModels } from '../@shared/Models/AccessModels';
import { FlexBoxInline, InputBaseSx, PrimaryBtnSx } from '../@shared/templates';
import { Palette, Sizes } from '../@shared/palette';

export const withAccessControlModel = <T extends Record<string, unknown>>(
  Component: React.ComponentType<T>
): React.FC<T> => (props) => {
  const [email, setEmail] = React.useState<string | undefined>("");
  const dispatch = useDispatch();
  const handleClose = () => dispatch(closeAccessModel())
  const [selectedUser, setSelectedUser] = React.useState<string | null>(null);

  const isOpen = useSelector(getIsShowAccessModal);
  const modelId = useSelector(getOpenedAccessModelId);
  const list = useSelector(getAccessList);
  const search = useSelector(getSearchedUsers);

  const onUpdateAccess = React.useCallback((email: string | undefined, role: AIAccessTypeEnum) => {
    if (email) {
      dispatch(updateAccessModel({ accessEmail: email, accessTypeId: role, schemaId: modelId } as CreateAccessesToModels))
    }
  }, [dispatch, modelId]);

  const onRemoveAccess = React.useCallback((email: string) => {
    dispatch(removeAccessModel(email))
  }, [dispatch]);

  return <>
    <ModalBase
      isOpen={isOpen}
      onCancel={handleClose}
      title="Share"
    >
      <Box
        sx={{
          ...FlexBoxInline,
          width: '100%',
          padding: '0 0',
          marginBottom: '10px'
        }}
      >
        <Autocomplete
          id="user-selector"
          freeSolo
          sx={{ ...InputBaseSx, width: '100%' }}
          size='small'
          onInputChange={(_, str) => {
            if (str) {
              dispatch(searchAccessModel({ str, id: modelId }))
            }
            setEmail(str)
          }}
          slotProps={
            {
              paper: {
                sx: {
                  fontSize: Sizes.textPrimary,
                  color: Palette.textColorPrimary,
                  backgroundColor: Palette.backgroundColorPrimary
                }
              }
            }
          }
          value={selectedUser}
          options={search.map(x => x.email)}
          inputValue={email}
          renderInput={(params) => <TextField {...params} label="Search" />}
        />

        <Button sx={PrimaryBtnSx} onClick={() => {
          onUpdateAccess(email, AIAccessTypeEnum.Observer)
          setSelectedUser(null)
        }}>Share</Button>
      </Box>


      <Box sx={{
        width: '100%',
        display: "flex",
        flexDirection: "column",
        gap: "10px"
      }}>
        {list && list.map((value) => <AccessUserItem key={value.id} accesses={value} onUpdateAccess={onUpdateAccess} onRemoveAccess={onRemoveAccess} />)}
      </Box>
    </ModalBase>
    <Component {...props as T} />
  </>
}